import { BsChat, BsEnvelope, BsPhone } from "react-icons/bs";
import { PropertyTypeConjuctionDic } from "../layout/table/filter/Filter.types";
import { FieldsType, Menu, FieldsClauseType } from "../types/layout";
import { EmailUpdates, UserRole } from "../types/page";
import { Card } from "../types/static";
import { FileOptionType, Stats } from "../types/ui";
import { formatDateToReadableShortString, formatDateToReadableString, formatDateToStrings } from "./others";

export const menuItems: Menu = [
    {
        key: 'overview',
        iconType: "Dashboard",
        label: 'Overview',
        subMenu: null,
        url: ''
   },
   {
        key: 'clients',
        iconType: "Client",
        label: 'Clients',
        subMenu: null,
        url: ''
   },
   {
        key: 'orders',
        iconType: "Paperclip",
        label: 'Orders',
        subMenu: null,
        url: ''
   },
   {
        key: 'reports',
        iconType: "Reports",
        label: 'Reports',
        url: null,
        subMenu: {
            key: "sub0",
            items: [
                {
                    key: 'complaints',
                    label: 'Complaints',
                    url: ''
                },
                {
                    key: 'sales',
                    label: 'Sales Reports',
                    url: ''
                },
                {
                    key: 'compliance',
                    label: 'Compliance Reports',
                    url: ''
                },
            ]     
        }
   },
   {
        key: 'products',
        iconType: "Clock",
        label: 'Products',
        url: null,
        subMenu: {
            key: "sub2",
            items: [
                {
                    key: 'stats',
                    label: 'Products Stats',
                    url: ''
                },
                {
                    key: 'images',
                    label: 'Products Images',
                    url: ''
                },
            ]
        } 
   },
   {
        key: 'documents',
        iconType: "Notes",
        label: "Documents",
        subMenu: null,
        url: ''
   },
   {
        key: 'settings',
        iconType: "Settings",
        label: "Settings",
        url: null,
        subMenu: {
            key: "sub3",
            items: [
                {
                    key: 'profile',
                    label: 'Profile Overview',
                    url: ''
                },
                {
                    key: 'account',
                    label: 'Account',
                    url: ''
                },
                {
                    key: 'billings',
                    label: 'Billings',
                    url: ''
                },
                {
                    key: 'notifications',
                    label: 'Notifications',
                    url: ''
                },
                {
                    key: 'invite',
                    label: 'Invite a team member',
                    url: ''
                }
            ]
        } 
   },
]

export const tagStatuses = [
    { id: 'waitlisted', name: 'waitlisted' },
    { id: 'settled', name: 'settled' },
    { id: 'rejected', name: 'rejected' },
    { id: 'accepted', name: 'accepted' }
];

export const countries = [
    { id: 'US', name: 'USA' },
    { id: 'GB', name: 'United Kingdom' },
    { id: 'BR', name: 'Brazil' },
    { id: 'CM', name: 'Cameroon' },
    { id: 'NG', name: 'Nigeria' }
];

export const fields: FieldsType = {
    country: countries,
    status: tagStatuses,
    dateRange: 'dob',
    dateofBirth: 'time'
}

export const fieldClauseMatch: FieldsClauseType = {
    country: ["is", "not in"],
    status: ["is"],
    dateRange: ["is", "between"],
    dateofBirth: ["is"],
    tagIds: []
}

// export const groupList = [
//     { id: "0", name: "Order 1100" }, 
//     { id: "1", name: "Order 1101" }
// ]

export const SORT_ORDER_LIST = [
    { label: "Ascending", value: "ASC" },
    { label: "Descending", value: "DESC" }
];

export const overviewItemsList = [
    'newUsers', 
    'campaignSent', 
    'dailyAverageIncome',
    'websiteVisits',
    'revenue',
    'incomeEarned',
    'conversionRates',
    'newsUpdate',
    'trafficCategory'
];

export const FILTER_CONJUCTIONS = [
    { label: "And", value: "and" },
    { label: "Or", value: "or" }
];

export const TEXT_FIELD_FILTERS = [
    "is", 
    "is not", 
    "contains", 
    "does not contain", 
    "starts with",
    "ends with",
    "is empty",
    "is not empty"
];

export const DATE_FIELD_FILTERS = [
    "is",
    "is within",
    "is before",
    "is after",
    "is on or after",
    "is empty",
    "is not empty",
    "exact date",
    "today",
    "tomorrow",
    "yesterday",
    "one week ago",
    "one week from now",
    "one month ago",
    "one month from now"
]
export const SELECT_FIELD_FILTER = ["is", "is not", "is empty", "is not empty"];

export const MULTI_SELECT_FIELD_FILTERS = ["contains", "does not contain", "is empty", "is not empty"];

export const MEDIA_FIELD_FILTERS = ["is empty", "is not empty"];

export const PROPERTY_TYPE_OPERATORS = {
    url: TEXT_FIELD_FILTERS,
    text: TEXT_FIELD_FILTERS,
    email: TEXT_FIELD_FILTERS,
    number: TEXT_FIELD_FILTERS,
    date: DATE_FIELD_FILTERS,
    select: SELECT_FIELD_FILTER,
    "phone number": TEXT_FIELD_FILTERS,
    "multi select": MULTI_SELECT_FIELD_FILTERS
} as PropertyTypeConjuctionDic;

export const stats = [
    {id: 1, type: 'email', label: 'Send Email', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 2, type: 'follow_up', label: 'Follow up with customer', amount:'£0.00', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 3, type: 'recording', label: 'Video call', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 4, type: 'recording', label: 'Recording', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 6, type: 'review', label: 'Review recordings', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 5, type: 'analysis', label: 'Perform analysis', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 7, type: 'email', label: 'Share on social media', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 8, type: 'folow_up', label: 'Chase customer', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 9, type: 'revenue', label: 'Collect fees', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
    {id: 10, type: 'revenue', label: 'Allocate revenue', amount:'$209,000', deals: 4 , date: formatDateToStrings('2019-12-30T08:22:37')},
] as Stats[]

export const userRoles = [
    { id: '1', label: 'Admin', type: 'admin' },
    { id: '2', label: 'User', type: 'user' },
    { id: '3', label: 'Merchant', type: 'client' },
    { id: '4', label: 'Developer', type: 'developer' },
] as UserRole[]

export const sortValues = ["Newest", "Oldest", "Date Added", "Date Modified"];

export const documentTypes = [
    {key: 'pdf', label: 'PDF', accept: 'application/pdf'},
    {key: 'folder', label: 'Folder'},
    {key: 'file', label: 'File (PNG, JPG, TXT)', accept: 'image/*,application/json'},
    {key: 'multiple_files', label: 'Multiple Files', accept: 'image/*,application/json' },
    {key: 'json', label: 'JSON files', accept: 'application/json' },
    {key: 'csv', label: 'CSV', accept: 'text/csv' },
] as FileOptionType[];

export const currencySymbols = {
    "USD": "$",
    "NGN": "N",
    "YEN": "¥",
    "EUR": "£",
    "GBP": "¢"
}

export const twoFactorOptions = [
    { 
        icon: BsPhone, 
        label: 'Authenticator app',
        description: 'Use an authentication app to get a two-factor authentication code to complete sign-in.', 
        type: 'authenticator' },
    { 
        icon: BsChat, 
        label: 'SMS/Text message',
        description: 'Get a one-time code sent to your phone via SMS to complete sign-in.', 
        type: 'code_sms' },
    { 
        icon: BsEnvelope, 
        label: 'Code via email', 
        type: 'code_email',
        description: 'Get a one-time code sent to your email to complete sign-in.', 
    },
]

export const EmailNotificationsOptions = [
    {key: 'all', desc: 'All notifications (mentions, direct messages and announcements).'},
    {key: 'dms', desc: 'Only mentions and direct messages.'},
    {key: 'mentions_dms', desc: 'Only direct mesages.'},
    {key: 'never', desc: 'Never'},
]

export const SignInNotificationsOptions = [
    {key: 'premium', desc: 'Send alerts when sign in occurs on an unrecognized or new device.'},
    {key: 'standard', desc: 'Send alerts when sign in occurs on a different location.'},
    {key: 'never', desc: "Don't send me any sign-in notification."},
]

export const emailUpdates = [
    {key: 'tips_tricks', title: 'Tips and Tricks.'},
    {key: 'offers_promotions', title: 'Offers and promotions.'},
    {key: 'marketing_newsletters', title: "Elem-Pro marketing newsletters."},
    {key: 'webinars', title: "Elem-Pro business webinars."},
] as EmailUpdates[]

export const cards = [
    {
        id: '1234',
        masked: '531134XXXXXX9822',
        expDate: '1031',
        type: 'MASTERCARD',
        address: '11, Oppawe, Loas',
        city: 'LAG',
        state: 'LAG'
    },
    {
        id: '2345',
        masked: '531134XXXXXX9822',
        expDate: '1031',
        type: 'VISA',
        address: '11, Oppawe, Loas',
        city: 'LAG',
        state: 'LAG'
    }
] as Card[]

export const payments = [
    {
        id: '1234',
        masked: '9822',
        price: 2900,
        type: 'Card',
        currency: 'YEN',
        duration: formatDateToReadableString('2021-06-28T07:48:34'),
        dateBilled: formatDateToReadableShortString('2021-06-28T07:48:34')
    },
    {
        id: '1234',
        masked: '9822',
        price: 2900,
        type: 'Card',
        currency: 'YEN',
        duration: formatDateToReadableString('2021-06-28T07:48:34'),
        dateBilled: formatDateToReadableShortString('2021-06-28T07:48:34')
    },
];
